(function () {
    "use strict";

    Solovis.defineNamespace("Solovis.InvDataSelectors");

    var EntityOrInvestmentSelectorControl = Solovis.defineClass(
        "Solovis.InvDataSelectors.EntityOrInvestmentSelectorControl",
        Solovis.UI.BaseControl,
        function (options) {
            // selectionCallback should be a function that takes an item.
            this.selectionCallback = options.selectionCallback ? options.selectionCallback : null;
            this.cancelCallback = options.cancelCallback ? options.cancelCallback : null;
            this._portalServices = options.portalServices;

            this._initialValue = options.initialValue ? options.initialValue : null;
        });


    EntityOrInvestmentSelectorControl.prototype.doInit = function () {
    };

    EntityOrInvestmentSelectorControl.prototype.setAvailableHeight = function (overallHeight) {

        var radioHeight = this._radioDiv.outerHeight();
        var availableHeight = overallHeight - radioHeight;

        this.investmentSelectorControl.setAvailableHeight(availableHeight);
    };

    EntityOrInvestmentSelectorControl.prototype.doRender = function () {
        var self = this;

        var entityOrInvestmentRadioName = _.uniqueId("entityOrInvestment_");

        this._radioDiv = $("<div>")
            .css("box-sizing", "border-box")
            .addClass("solovis-input")
            .css("padding", "5px 0 10px 10px")
            .appendTo(this.container);

        var entityLabel = $("<label>")
            .text("Entity")
            .addClass("radio-inline")
            .appendTo(this._radioDiv);

        this.entityRadioButton = $("<input>")
            .attr("type", "radio")
            .attr("name", entityOrInvestmentRadioName)
            .appendTo(entityLabel);

        var investmentLabel = $("<label>")
            .text("Investment")
            .addClass("radio-inline")
            .appendTo(this._radioDiv);

        this.investmentRadioButton = $("<input>")
            .attr("type", "radio")
            .attr("name", entityOrInvestmentRadioName)
            .appendTo(investmentLabel);

        this.entitySelectorDiv = $("<div>").css("display", "none").appendTo(this.container);

        var minWidth = 150;
        var minHeight = 75;

        this.investmentSelectorDiv = $("<div>")
            .css("display", "none")
            .css("min-width", minWidth + "px")
            .css("min-height", minHeight + "px")
            .appendTo(this.container);

        var toggleVisibleInput = function () {
            if (self.entityRadioButton.is(":checked")) {
                $(self).trigger("currentViewInfoChanged");

                self.entitySelectorDiv.show();
            }
            else {
                self.entitySelectorDiv.hide();
            }

            if (self.investmentRadioButton.is(":checked")) {

                self.investmentSelectorDiv.show();
                self.investmentSelectorControl.focus();
            }
            else {
                self.investmentSelectorDiv.hide();
            }
        };

        this.entityRadioButton.change(toggleVisibleInput);
        this.investmentRadioButton.change(toggleVisibleInput);

        var entitySelectorControlHostDiv = $("<div>").appendTo(this.entitySelectorDiv);
        this.entitySelectorControlHost = new Solovis.UI.ControlHost({ container: entitySelectorControlHostDiv });
        this.entitySelectorControl = new Solovis.InvDataSelectors.EntitySelectorControl({
            controlHost: this.entitySelectorControlHost,
            portalServices: this._portalServices,

            selectionCallback: function (entity) {
                self._notifyItemSelected(entity);
            },
            cancelCallback: function () {
                if (self.cancelCallback) {
                    self.cancelCallback();
                }
            }
        });

        this.entitySelectorControlHost.setCurrentControl(this.entitySelectorControl);

        this.entitySelectorControl.searchBox
            .css("min-width", minWidth + "px")
            .css("width", "100%");

        var investmentSelectorControlHostDiv = $("<div>").appendTo(this.investmentSelectorDiv);
        this.investmentSelectorControlHost = new Solovis.UI.ControlHost({ container: investmentSelectorControlHostDiv });
        this.investmentSelectorControl = new Solovis.InvDataSelectors.InvestmentSelectorControl({
            controlHost: this.investmentSelectorControlHost,
            portalServices: this._portalServices,
            initialValue: this._initialValue,
            selectionCallback: function (investment) {
                self._notifyItemSelected(investment);
            },
            cancelCallback: function () {
                if (self.cancelCallback) {
                    self.cancelCallback();
                }
            }
        });

        $(this.investmentSelectorControl).on("currentViewInfoChanged", function () {            
            $(self).trigger("currentViewInfoChanged");
        });

        this.investmentSelectorControlHost.setCurrentControl(this.investmentSelectorControl);
    };

    EntityOrInvestmentSelectorControl.prototype._notifyItemSelected = function (entityOrInvestment) {
        if (this.selectionCallback) {
            this.selectionCallback(entityOrInvestment);
        }
    };

    EntityOrInvestmentSelectorControl.prototype.getCurrentViewInfo = function () {
        var viewInfo: any = {
        };

        if (this.entityRadioButton.is(":checked")) {
            viewInfo.isEntity = true;
        }
        else if (this.investmentRadioButton.is(":checked")) {
            viewInfo.isInvestment = true;
            viewInfo.investmentSelector = this.investmentSelectorControl ? this.investmentSelectorControl.getCurrentViewInfo() : null;
        }        

        return viewInfo;
    };

})();